import { z } from 'zod';

export const PresenceFocusSchema = z.object({
  slideId: z.string().optional(),
  sheetId: z.string().optional(),
  /** A1 range on the focused sheet, e.g. "B2:D9". */
  range: z.string().optional(),
});
export type PresenceFocus = z.infer<typeof PresenceFocusSchema>;

export const PresenceParticipantSchema = z.object({
  /** Human participants carry the realtime connectionId; agents carry their runId. */
  connectionId: z.string(),
  userId: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  kind: z.enum(['human', 'agent']),
  focus: PresenceFocusSchema.nullable(),
  idle: z.boolean(),
});
export type PresenceParticipant = z.infer<typeof PresenceParticipantSchema>;

export const LockHolderKindSchema = z.enum(['agent', 'human']);
export type LockHolderKind = z.infer<typeof LockHolderKindSchema>;

export const DocumentLockDtoSchema = z.object({
  resourceId: z.string(),
  /** Set for element-level locks: the slideId / sheetId the resource lives under. */
  parentResourceId: z.string().nullable(),
  holderKind: LockHolderKindSchema,
  holder: z.object({
    userId: z.string().optional(),
    name: z.string().optional(),
    runId: z.string().optional(),
    connectionId: z.string().optional(),
  }),
});
export type DocumentLockDto = z.infer<typeof DocumentLockDtoSchema>;

export const LockResourceRequestSchema = z.object({
  resourceId: z.string(),
  parentResourceId: z.string().optional(),
});
export type LockResourceRequest = z.infer<typeof LockResourceRequestSchema>;

export function elementLockResourceId(slideId: string, elementId: string) {
  return `element:${slideId}:${elementId}`;
}

export function cellLockResourceId(sheetId: string, a1Ref: string) {
  return `cell:${sheetId}:${a1Ref}`;
}
